import { componentFactory } from 'vue-tsx-support';

import { injectStylesMixin } from '../../mixins/inject-styles';

import styles from './jtn-ui-checkbox.styles.scss?module';

const CHECKBOX_ICON_SIZE = 16;

export default componentFactory.mixin(injectStylesMixin(styles)).create({
  name: 'JtnUiCheckbox',
  props: {
    value: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    size: {
      type: String as () => 'big' | 'small' | 'bigReverse',
      default: 'big'
    }
  },
  render() {
    const attributes = {
      attrs: this.$attrs,
      on: this.$listeners
    };

    return (
      <label class={styles.checkboxWrap}>
        <input
          value={this.value}
          name={this.name}
          class={styles.inputHidden}
          type="checkbox"
          {...attributes}
        />
        <p class={[styles.inner, styles[this.size]]}>
          <span class={styles.checkbox}>
            <svg width={CHECKBOX_ICON_SIZE} height={CHECKBOX_ICON_SIZE}>
              <use xlinkHref="/dist/legacy/svg-sprites/jtn-common.f7875ac1d2b1e964bfa6c21ef5757c8a.svg#jtn-common-checkbox"></use>
            </svg>
          </span>
          <span class={styles.text}>{this.$slots.default}</span>
        </p>
      </label>
    );
  }
});
